"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderProfileBadge = exports.Badge = exports.BadgeContainer = exports.BadgeWrapper = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const chip_1 = __importDefault(require("@kyruus/chip"));
const badges_1 = require("../common/util/badges");
exports.BadgeWrapper = styled_1.default.div `
  display: flex;
  flex-wrap: wrap;
`;
exports.BadgeContainer = styled_1.default.div `
  border-left: 2px ${(0, ui_theme_1.fromTheme)('border_style')} ${(0, ui_theme_1.fromTheme)('color_link')};
  margin: 0 ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0 0;
`;
exports.Badge = styled_1.default.span `
  display: inline-block;
  padding: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  text-transform: uppercase;
  vertical-align: baseline;
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_background_badge')};
  border-left-width: 0;
`;
exports.ProviderProfileBadge = (0, styled_1.default)(chip_1.default, {
    shouldForwardProp: (prop) => prop !== 'color'
}) `
  && {
    color: ${(0, ui_theme_1.fromTheme)('color_text_contrast')};
    background-color: ${(_a) => {
    var { color } = _a, restProps = __rest(_a, ["color"]);
    return (0, badges_1.getBackgroundColorFromVariant)(color, restProps);
}};
    border-color: ${(_a) => {
    var { color } = _a, restProps = __rest(_a, ["color"]);
    return (0, badges_1.getBorderColorFromVariant)(color, restProps);
}};
    border-radius: ${(0, ui_theme_1.fromTheme)('border_radius_badge_chip')};
    border-width: ${(0, ui_theme_1.fromTheme)('border_width')};
    border-style: ${(0, ui_theme_1.fromTheme)('border_style')};
    font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
    font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
    margin-right: ${(0, ui_theme_1.fromTheme)('spacing_small')};
    line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  }
`;
//# sourceMappingURL=ProviderBadges.styles.js.map